/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthCareServiceMetadataModel } from '../../models/health-care-service-metadata-model';

export interface AdminLocationsSpecialitiesHealthCareServiceFhirIdGet$Params {
  healthCareServiceFhirId: string;
}

export function adminLocationsSpecialitiesHealthCareServiceFhirIdGet(http: HttpClient, rootUrl: string, params: AdminLocationsSpecialitiesHealthCareServiceFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<HealthCareServiceMetadataModel>> {
  const rb = new RequestBuilder(rootUrl, adminLocationsSpecialitiesHealthCareServiceFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('healthCareServiceFhirId', params.healthCareServiceFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<HealthCareServiceMetadataModel>;
    })
  );
}

adminLocationsSpecialitiesHealthCareServiceFhirIdGet.PATH = '/Admin/LocationsSpecialities/{healthCareServiceFhirId}';
